import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type FiltersForm from 'modules/core/lib/forms/Filters'

interface SortableHeaderProps {
  attribute: string
  filtersForm: FiltersForm
}

const SortableHeader = observer(
  ({ attribute, filtersForm, children }: React.PropsWithChildren<SortableHeaderProps>) => {
    const sortDirection = filtersForm.get('sortDirection')
    const sortAttribute = filtersForm.get('sortAttribute')

    return (
      <Table.SortableHeadCell
        colSpan={5}
        onSort={(attr, direction) => {
          sortDirection.set(direction)
          sortAttribute.set(attr)
        }}
        attribute={attribute}
        sortAttribute={sortAttribute.value}
        sortDirection={sortDirection.value}
      >
        {children}
      </Table.SortableHeadCell>
    )
  }
)

export default SortableHeader
